import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const FixedPoleFlatAllTerrain = () => {
  console.log('🎯 FixedPoleFlatAllTerrain component loading');
  
  const product = findProductById("fixed-pole-flat-all-terrain");
  
  if (!product) {
    console.error('Product not found:', "fixed-pole-flat-all-terrain");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="fixed-pole-flat-all-terrain"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default FixedPoleFlatAllTerrain; 